/* oxlint-disable react-doctor/rendering-hydration-mismatch-time */
import { DatePickerField } from 'components/forms/inputs/common/DatePickerField';
import { useEffectiveDateFormat } from 'hooks/useEffectiveDateFormat';
import React, { useEffect } from 'react';
import { t } from 'utils/getTranslations.ts';
import { getSelectorKey } from '../../getSelectorKey.ts';
import { DateFilterForm, MainFilterForm, QuickFilterForm } from '../../ListTableTypes.tsx';
import { FilterLabel } from './FilterLabel';

export const DateSelector: React.FC<{
    filter: DateFilterForm;
    quickFilters: QuickFilterForm;
    mainFilters: MainFilterForm;
    onChange: (value: string | null, groupSelector: string) => void;
}> = React.memo(({ filter, onChange, quickFilters, mainFilters }) => {
    const effectiveFormat = useEffectiveDateFormat();
    const isHidden =
        filter.getShouldHide !== undefined
            ? filter.getShouldHide({
                  mainFilters,
                  quickFilters,
                  groupSelector: getSelectorKey(filter),
              })
            : false;

    useEffect(() => {
        // Only when there is something to drop: `onChange` re-renders the whole drawer, so clearing an
        // already-empty filter on every render of a hidden one would loop.
        if (isHidden && !filter?.preserveValueWhenHidden && filter.value != null) {
            onChange(null, getSelectorKey(filter));
        }
    }, [filter, isHidden, onChange]);

    if (isHidden) {
        return null;
    }

    return (
        <div className="flex grow flex-col gap-2" key={`filter-${getSelectorKey(filter)}`}>
            {filter.label && (
                <FilterLabel label={filter.label} tooltip={filter.tooltip} tooltipValues={filter.tooltipValues} />
            )}
            <DatePickerField
                format={effectiveFormat}
                value={filter.value ? new Date(filter.value) : null}
                onChange={(val: Date | null) => {
                    onChange(val !== null ? String(val) : null, getSelectorKey(filter));
                }}
                placeholder={t('forms.select-date')}
            />
        </div>
    );
});
